import * as types from './mutation-types'

export default {
  [types.SET_CLASS](state, payload) {
    state.gymClass = payload
  },
  [types.SET_CLASS_SCHEDULE](state, payload) {
    state.classSchedule = payload
  },
  [types.SET_ARRAY_CLASS_SCHEDULE](state, payload) {
    state.gymClass.classSchedules.push(...payload);
  },
  [types.SET_SHOW_CLASS_DIALOG](state, payload) {
    state.showDialog = payload
  },
  [types.SET_SHOW_CLASS_TIME_DIALOG](state, payload) {
    state.showClassTimeDialog = payload
  }
}